import { ReactNode, useRef } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const DisabledExplanationTooltip = ({
  children,
  disabled,
  message,
  side = "top",
}: {
  children: ReactNode;
  disabled: boolean;
  message: string;
  side?: "top" | "bottom" | "left" | "right";
}) => {
  const hoverTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  if (!disabled) {
    return <>{children}</>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onMouseEnter={() => {
              hoverTimerRef.current = setTimeout(() => {
                mixpanelUtils.trackHover(
                  "Disabled element tooltip",
                  getScreenFromPathname(window.location.pathname),
                );
              }, 300);
            }}
            onMouseLeave={() => {
              if (hoverTimerRef.current) {
                clearTimeout(hoverTimerRef.current);
                hoverTimerRef.current = null;
              }
            }}
          >
            {children}
          </div>
        </TooltipTrigger>
        <TooltipContent className="mb-3" side={side}>
          <p>{message}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
